<div class="container my-3 p-3 General container-fluid">
  <h3>Newsletters</h3>
  <h4>{{ "Newsletter.touch" | translate }}</h4>
  <p>{{ "Newsletter.SearchDescription" | translate }}</p>
  <div #govDeliverySignup class="row">

    <!-- <script src="https://public.govdelivery.com/assets/SignupOverlay.js" data-account-code="CALACOUNTY" data-signup-id="50489" async="" data-width="500" data-delay="0"></script> -->
    <!-- <div class="col-md-6">
      <iframe alt="General Newsletter"
        src="https://us11.list-manage.com/subscribe?u=3d79962a0e2ac6a48c94d04e8&id=a94f29972c"
        width="100%"
        height="300px"
        style="border: none"
      ></iframe>
    </div>
    <div class="col-md-6">
      <iframe alt="Real Estate Pro Newsletter"
        src="https://lacounty.us11.list-manage.com/subscribe?u=3d79962a0e2ac6a48c94d04e8&id=d531fa6ede"
        width="100%"
        height="300px"
        style="border: none"
      >
      </iframe>
    </div> -->
  </div>
  <!-- <h4>{{ "Newsletter.PropertyOwnerAlert" | translate }}</h4>
  <p>{{ "Newsletter.AlertDesc" | translate }} </p>
  <a class="btn btn-primary mb-4" [href]="envService.portalUrl" target="_blank">
    <span>{{ "Newsletter.Signup" | translate }}</span>
  </a>
  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop [isOpen]="false">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            FAQ
            <i
              class="mt-1 float-end"
              [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="PropAlertBody" >
          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WhatisPropAlert" | translate }}</h6>
          <p [innerHTML]="'Newsletter.ThePropAlert'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.HowtoEnroll" | translate }}</h6>
          <p [innerHTML]="'Newsletter.ToEnroll'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.IsThereaLimit" | translate }}</h6>
          <p [innerHTML]="'Newsletter.ThereisNoLimit'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WhyistheCounty" | translate }}</h6>
          <p [innerHTML]="'Newsletter.TheCounty'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WillthePaper" | translate }}</h6>
          <p [innerHTML]="'Newsletter.ENotification'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.IsthereaFee" | translate }}</h6>
          <p [innerHTML]="'Newsletter.NoFee'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WillIContinue" | translate }}</h6>
          <p [innerHTML]="'Newsletter.OnceYouEnroll'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.AreTheProperty" | translate }}</h6>
          <p [innerHTML]="'Newsletter.TheNotifications'|translate"></p>

          <h6 style="margin-bottom: 0rem;">{{ "Newsletter.WhotoContact" | translate }}</h6>
          <p [innerHTML]="'Newsletter.ToSpeak'|translate"></p>

        </div>
      </accordion-group>
    </accordion>
  </div> -->


  <!-- <hr style="background-color:black;">
  <h4>Newsletter Archives</h4>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop11 [isOpen]="true">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2026
            <i
              class="mt-1 float-end"
              [ngClass]="!drop11.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>

        <div class="display_archive">
          <div class="campaign">
            07/29/2026 -
            <a
              href="https://content.govdelivery.com/accounts/CALACOUNTY/bulletins/41f8315"
              title=" 2026 Summer Newsletter"
              target="_blank"
              >2026 Summer Newsletter</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            06/11/2026 -
            <a
              href="https://lnks.gd/3/3WMVPMp"
              title="Newsletter Highlights National Case Study of Assessor Modernization"
              target="_blank"
              >Newsletter Highlights National Case Study of Assessor Modernization</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            03/26/2026 -
            <a
              href="https://lnks.gd/3/3TDtr9b"
              title="The Spring Newsletter Is Here."
              target="_blank"
              >The Spring Newsletter Is Here.</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            01/12/2026 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=abcf3d9e07"
              title="2026 Newsletter Highlights Disabled Veterans, Inheritance Issues & ADUs"
              target="_blank"
              >2026 Newsletter Highlights Disabled Veterans, Inheritance Issues & ADUs</a
            >
          </div>
        </div>

        </accordion-group>
    </accordion>
  </div>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop11 [isOpen]="false">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2025
            <i
              class="mt-1 float-end"
              [ngClass]="!drop11.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>

        <div class="display_archive">
          <div class="campaign">
            11/07/2025 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=6a0994422b"
              title="Newsletter Highlights New Technology & Much More"
              target="_blank"
              >Newsletter Highlights New Technology & Much More</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            09/09/2025 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=d525d58e02"
              title="Newsletter Highlights 2025 Assessment Roll"
              target="_blank"
              >Newsletter Highlights 2025 Assessment Roll</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            07/02/2025 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=c9192e4ddd"
              title="Rebuilding After A Disaster? Know These Key Assessment Rules"
              target="_blank"
              >Rebuilding After A Disaster? Know These Key Assessment Rules</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            06/02/2025 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=df0e571672"
              title="Newsletter 2025 Highlights Wildfires, Legislative Fixes & Much More"
              target="_blank"
              >Newsletter 2025 Highlights Wildfires, Legislative Fixes & Much More</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            01/04/2025 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=311fcab0a4"
              title="Newsletter Highlights 2024 Annual Report"
              target="_blank"
              >Newsletter Highlights 2024 Annual Report</a
            >
          </div>
        </div>




      </accordion-group>
    </accordion>
  </div>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop10 [isOpen]="false">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2024
            <i
              class="mt-1 float-end"
              [ngClass]="!drop10.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>

        <div class="display_archive">
          <div class="campaign">
            11/09/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=6a82c79081"
              title="Natural Disaster Tax Relief & More in Assessor's Newsletter"
              target="_blank"
              >Natural Disaster Tax Relief & More in Assessor's Newsletter</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            09/16/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=8ca2c2863f"
              title="$2 Trillion 2024 Assessment Roll is Reviewed in Detail"
              target="_blank"
              >$2 Trillion 2024 Assessment Roll is Reviewed in Detail</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            06/27/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=582039e2d3"
              title="Newsletter: Estimating Supplemental Taxes"
              target="_blank"
              >Newsletter: Estimating Supplemental Taxes</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            05/25/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=e06ae67d1d"
              title="Newsletter Highlights: The Story behind Granny Flats; Search Tool & More"
              target="_blank"
              >Newsletter Highlights: The Story behind Granny Flats; Search Tool & More</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            04/18/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=04f42b7370 "
              title="Business Property Statements Nearing Final Deadline"
              target="_blank"
              >Business Property Statements Nearing Final Deadline</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            03/12/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=5fbbc1556b"
              title="Newsletter Updates Disaster Relief, 2024 Fair, Veterans' Exemptions"
              target="_blank"
              >Newsletter Updates Disaster Relief, 2024 Fair, Veterans' Exemptions</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            02/02/2024 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=3bc61be950"
              title="February Newsletter Highlights Homeowners' Exemption Deadline"
              target="_blank"
              >February Newsletter Highlights Homeowners' Exemption Deadline</a
            >
          </div>
        </div>


      </accordion-group>
    </accordion>
  </div>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop9 [isOpen]="false">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2023
            <i
              class="mt-1 float-end"
              [ngClass]="!drop9.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>

        <div class="display_archive">
          <div class="campaign">
            12/04/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=a23f098ae6"
              title="Winter Newsletter Highlights 2023 Annual Report, Innovative Mapping Tool"
              target="_blank"
              >Winter Newsletter Highlights 2023 Annual Report, Innovative Mapping Tool</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            09/22/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=9851ef80b4"
              title="Digital Age is Here; Change Your Mailing Address Electronically"
              target="_blank"
              >Digital Age is Here; Change Your Mailing Address Electronically</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            08/24/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=0d67b6555b"
              title="Assessment Roll, Solar Panels, Landslide Victims & Dates Highlight Newsletter"
              target="_blank"
              >Assessment Roll, Solar Panels, Landslide Victims & Dates Highlight Newsletter</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            07/12/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=9fb4e17a4f"
              title="Summer Newsletter"
              target="_blank"
              >Summer Newsletter</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            06/29/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=7afc891727"
              title="Market Forecast Newsletter"
              target="_blank"
              >Market Forecast Newsletter</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            05/02/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=82c8cc21b0"
              title="May Newsletter Spotlights BPP Deadline; Assessor ChatBot, Pre-Sale Tips & More"
              target="_blank"
              >May Newsletter Spotlights BPP Deadline; Assessor ChatBot, Pre-Sale Tips & More</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            03/20/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=463baeeb47 "
              title="March Newsletter | Deadlines Approaching For BPP Statements!"
              target="_blank"
              >March Newsletter | Deadlines Approaching For BPP Statements!</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            02/09/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=8f2adbabf0 "
              title="February Newsletter | Disaster Relief Available"
              target="_blank"
              >February Newsletter | Disaster Relief Available</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            01/06/2023 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=797df8c00b"
              title="Winter Newsletter Highlights Assessor's Oath of Office & Tax Savings"
              target="_blank"
              >Winter Newsletter Highlights Assessor's Oath of Office & Tax Savings</a
            >
          </div>
        </div>
      </accordion-group>
    </accordion>
  </div>

  <div class="accordion">
    <accordion [isAnimated]="true">
      <accordion-group #drop8 [isOpen]="false">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2022
            <i
              class="mt-1 float-end"
              [ngClass]="!drop8.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>

        <div class="display_archive">
          <div class="campaign">
            11/09/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=97302aa241"
              title="Fall Newsletter Showcases Resource Fair; Earth Slide Moves Homes"
              target="_blank"
              >Fall Newsletter Showcases Resource Fair; Earth Slide Moves Homes</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            09/28/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=34c44de52b"
              title="Assessor Office receives a top score by the State & a deeper dive into the Assessment Roll"
              target="_blank"
              >Assessor Office receives a top score by the State & a deeper dive into the Assessment Roll</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            08/25/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=0969dedf7b"
              title="August Newsletter Looks at Completed Roll; E-Notifications"
              target="_blank"
              >August Newsletter Looks at Completed Roll; E-Notifications</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            07/01/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=0cb60f133f"
              title="Latest Newsletter Focuses on Roll Closure, Decline-in-Value, Juneteenth"
              target="_blank"
              >Latest Newsletter Focuses on Roll Closure, Decline-in-Value, Juneteenth</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            05/27/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=d614ad787e"
              title="2022 Assessor Resource Fair; Roll May Forecast Near $1.9 Trillion"
              target="_blank"
              >2022 Assessor Resource Fair; Roll May Forecast Near $1.9 Trillion</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            04/27/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=9060998691"
              title="A Time for Spring Reflection While Moving Forward"
              target="_blank"
              >A Time for Spring Reflection While Moving Forward</a
            >
          </div>
        </div>

        <div class="display_archive">
          <div class="campaign">
            03/01/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=3f41755de0"
              title="Understanding the Past and Reflecting on the Future"
              target="_blank"
              >Understanding the Past and Reflecting on the Future</a
            >
          </div>
        </div>


        <div class="display_archive">
          <div class="campaign">
            02/01/2022 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=f85dd2cfb0"
              title="Homeowners' Exemption Month"
              target="_blank"
              >Homeowners' Exemption Month</a
            >
          </div>

        </div>
      </accordion-group>



      <accordion-group #drop1 [isOpen]="false">
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2021
            <i
              class="mt-1 float-end"
              [ngClass]="!drop1.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>

        <div class="display_archive">
          <div class="campaign">
            11/22/2021 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=cd00fb59a1"
              title="Escape Assessments - What you need to know"
              target="_blank"
              >Escape Assessments - What you need to know</a
            >
          </div>
          <div class="campaign">
            11/11/2021 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=53bfa9ac21"
              title="Veterans, thank you for your service!"
              target="_blank"
              >Veterans, thank you for your service!</a
            >
          </div>
          <div class="campaign">
            11/08/2021 -
            <a
              href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=8d799ecc3a"
              title="Partnership with Oracle to Bring Operations into 21st Century"
              target="_blank"
              >Partnership with Oracle to Bring Operations into 21st Century</a
            >
          </div>
          <div class="campaign">
            09/29/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=2fa8f79242"
              title="An innovative new jobs program with local colleges"
              target="_blank"
              >An innovative new jobs program with local colleges</a
            >
          </div>
          <div class="campaign">
            08/31/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=36b4ebf9b4"
              title="How to Understand the Annual Assessment Roll"
              target="_blank"
              >How to Understand the Annual Assessment Roll</a
            >
          </div>
          <div class="campaign">
            07/28/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=ef72155626"
              title="2021 Annual Assessment Roll"
              target="_blank"
              >2021 Annual Assessment Roll</a
            >
          </div>
          <div class="campaign mme_event-click">
            06/30/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=743aad4051"
              title="Reopening, reassessment, and refinancing"
              target="_blank"
              >Reopening, reassessment, and refinancing</a
            >
          </div>
          <div class="campaign">
            05/28/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=05d3ad8ef6"
              title="A Tale of Two Markets"
              target="_blank"
              >A Tale of Two Markets</a
            >
          </div>
          <div class="campaign">
            04/22/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=6051ca660a"
              title="Tax Breaks Went Into Effect April 1 – What That Means"
              target="_blank"
              >Tax Breaks Went Into Effect April 1 – What That Means</a
            >
          </div>
          <div class="campaign">
            03/29/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=1e049df411"
              title="The Impact of Prop. 19 – How does it affect you?"
              target="_blank"
              >The Impact of Prop. 19 – How does it affect you?</a
            >
          </div>
          <div class="campaign">
            02/18/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=451d287c5a"
              title="REVISED: February Newsletter: Proposition 19"
              target="_blank"
              >REVISED: February Newsletter: Proposition 19</a
            >
          </div>
          <div class="campaign">
            02/01/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=671f9534b1"
              title="LA County Tax Collector Reminds Homeowners of Deadline"
              target="_blank"
              >LA County Tax Collector Reminds Homeowners of Deadline</a
            >
          </div>
          <div class="campaign">
            01/19/2021 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=2609ced6bb"
              title="January Newsletter: Tax Savings Month &amp; Prop. 19 Webinar"
              target="_blank"
              >January Newsletter: Tax Savings Month &amp; Prop. 19 Webinar</a
            >
          </div>
        </div>
      </accordion-group>
      <accordion-group #drop2>
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2020
            <i
              class="mt-1 float-end"
              [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="display_archive">
          <div class="campaign">
            12/31/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e558acf793"
              title="Happy New Year! Stay Safe."
              target="_blank"
              >Happy New Year! Stay Safe.</a
            >
          </div>
          <div class="campaign">
            12/24/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=bd969f149a"
              title="Happy Holidays! Stay Safe."
              target="_blank"
              >Happy Holidays! Stay Safe.</a
            >
          </div>
          <div class="campaign">
            12/18/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=46d725e90c"
              title="LA County Assessor Prang Presents Pros, Cons on Prop. 19"
              target="_blank"
              >LA County Assessor Prang Presents Pros, Cons on Prop. 19</a
            >
          </div>
          <div class="campaign">
            11/25/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=78b0e8ba64"
              title="Happy Thanksgiving! Stay Safe."
              target="_blank"
              >Happy Thanksgiving! Stay Safe.</a
            >
          </div>
          <div class="campaign">
            11/11/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=72460d3d8e"
              title="Veterans Tax Resources"
              target="_blank"
              >Veterans Tax Resources</a
            >
          </div>
          <div class="campaign">
            10/26/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e24a065989"
              title="City-by-city data released!"
              target="_blank"
              >City-by-city data released!</a
            >
          </div>
          <div class="campaign">
            09/30/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=d78915ba2b"
              title="Wildfire Relief and Ownership Investigations"
              target="_blank"
              >Wildfire Relief and Ownership Investigations</a
            >
          </div>
          <div class="campaign">
            08/28/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=bde11d1c1b"
              title="Penalty Cancellation and Assessment Basics"
              target="_blank"
              >Penalty Cancellation and Assessment Basics</a
            >
          </div>
          <div class="campaign">
            07/27/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=2ac66ddaef"
              title="The Assessment Roll and Disaster Relief"
              target="_blank"
              >The Assessment Roll and Disaster Relief</a
            >
          </div>
          <div class="campaign">
            06/30/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=3f39a82ce7"
              title="June Newsletter: Tax Programs for Seniors, Solar Energy, and Domestic Partners"
              target="_blank"
              >June Newsletter: Tax Programs for Seniors, Solar Energy, and
              Domestic Partners</a
            >
          </div>
          <div class="campaign">
            05/28/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=6090fec31b"
              title="May Newsletter: Veterans' Benefits and Inheriting Property,"
              target="_blank"
              >May Newsletter: Veterans' Benefits and Inheriting Property,</a
            >
          </div>
          <div class="campaign">
            04/30/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=bc9e2826a2"
              title="April Newsletter: COVID Impact, Business Property Statements, Tax Relief, and more!"
              target="_blank"
              >April Newsletter: COVID Impact, Business Property Statements, Tax
              Relief, and more!</a
            >
          </div>
          <div class="campaign">
            03/09/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=86cd516c9d"
              title="March Newsletter: Free Business Seminars, Tax Relief for Seniors, Rosemead &amp; More!"
              target="_blank"
              >March Newsletter: Free Business Seminars, Tax Relief for Seniors,
              Rosemead &amp; More!</a
            >
          </div>
          <div class="campaign">
            02/06/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=fbc58e0be7"
              title="Newsletter: Keeping Your Home in the Family, Prop 13, Fair Market Value &amp; More!"
              target="_blank"
              >Newsletter: Keeping Your Home in the Family, Prop 13, Fair Market
              Value &amp; More!</a
            >
          </div>
          <div class="campaign">
            01/06/2020 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=70e2c2ca76"
              title="Newsletter: New Year's Savings, Boats, Escape Assessments &amp; More!"
              target="_blank"
              >Newsletter: New Year's Savings, Boats, Escape Assessments &amp;
              More!</a
            >
          </div>
        </div>
      </accordion-group>
      <accordion-group #drop3>
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2019
            <i
              class="mt-1 float-end"
              [ngClass]="!drop3.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="display_archive">
          <div class="campaign">
            10/24/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e690f0e18f"
              title="Newsletter: Disaster Relief, Remodels, Realtor Tips &amp; More!"
              target="_blank"
              >Newsletter: Disaster Relief, Remodels, Realtor Tips &amp;
              More!</a
            >
          </div>
          <div class="campaign">
            07/23/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=26cadd7cac"
              title="The numbers are in!"
              target="_blank"
              >The numbers are in!</a
            >
          </div>
          <div class="campaign">
            06/21/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=8343632246"
              title="Are you remodeling this summer?"
              target="_blank"
              >Are you remodeling this summer?</a
            >
          </div>
          <div class="campaign">
            05/30/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=a9d1cc18c5"
              title="Modernized Online Property Tax Portal Now Live"
              target="_blank"
              >Modernized Online Property Tax Portal Now Live</a
            >
          </div>
          <div class="campaign">
            04/08/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=7e5901d6bd"
              title="Save Money on Your Property Taxes"
              target="_blank"
              >Save Money on Your Property Taxes</a
            >
          </div>
          <div class="campaign">
            03/11/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=2ca41e9b75"
              title="March Madness: Four key events to attend this month"
              target="_blank"
              >March Madness: Four key events to attend this month</a
            >
          </div>
          <div class="campaign">
            01/18/2019 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=ce03e19a92"
              title="Are you overpaying on your property taxes?"
              target="_blank"
              >Are you overpaying on your property taxes?</a
            >
          </div>
        </div>
      </accordion-group>
      <accordion-group #drop4>
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2018
            <i
              class="mt-1 float-end"
              [ngClass]="!drop4.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="display_archive">
          <div class="campaign">
            12/06/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=df341768aa"
              title="Oath of Office, Disaster Relief, Save Time-Pay Prop. Tax Online"
              target="_blank"
              >Oath of Office, Disaster Relief, Save Time-Pay Prop. Tax
              Online</a
            >
          </div>
          <div class="campaign">
            11/15/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=faa405d470"
              title="Relief for wildfire victims and veterans"
              target="_blank"
              >Relief for wildfire victims and veterans</a
            >
          </div>
          <div class="campaign">
            10/25/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=1d6c466378"
              title="Property Taxes and Local Government are the Keys to LA Real Estate Market"
              target="_blank"
              >Property Taxes and Local Government are the Keys to LA Real
              Estate Market</a
            >
          </div>
          <div class="campaign">
            10/11/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=fd31d247c2"
              title="The Annual Report and new tax relief legislation"
              target="_blank"
              >The Annual Report and new tax relief legislation</a
            >
          </div>
          <div class="campaign">
            09/21/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=152297bec8"
              title="Learn How Senior and Disabled Homeowners May Postpone Paying Property Taxes"
              target="_blank"
              >Learn How Senior and Disabled Homeowners May Postpone Paying
              Property Taxes</a
            >
          </div>
          <div class="campaign">
            07/12/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=31a07ad576"
              title="Property Owners Affected by Wildfires, Save the Date, City of the Week"
              target="_blank"
              >Property Owners Affected by Wildfires, Save the Date, City of the
              Week</a
            >
          </div>
          <div class="campaign">
            06/28/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=10a06ebda3"
              title="Last Chance to Register, Prop 13 Turns 40, Tips from Assessor Prang"
              target="_blank"
              >Last Chance to Register, Prop 13 Turns 40, Tips from Assessor
              Prang</a
            >
          </div>
          <div class="campaign">
            06/14/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=057f405374"
              title="Results from BizFed's Pulse Poll, Attend Summer Seminars, and more!&nbsp;"
              target="_blank"
              >Results from BizFed's Pulse Poll, Attend Summer Seminars, and
              more!&nbsp;</a
            >
          </div>
          <div class="campaign">
            05/31/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=00a2142903"
              title="Attend Exemption Symposium, Vote this Weekend, Buying Property-Plan Ahead"
              target="_blank"
              >Attend Exemption Symposium, Vote this Weekend, Buying
              Property-Plan Ahead</a
            >
          </div>
          <div class="campaign">
            05/18/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=fde14d88bd"
              title="Moving Soon? Keep Your Property Taxes Low!"
              target="_blank"
              >Moving Soon? Keep Your Property Taxes Low!</a
            >
          </div>
          <div class="campaign">
            04/05/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=6f18220ebe"
              title="Making it Easy to Keep Property in the Family, We've Gone Social, and Take the Pulse Poll"
              target="_blank"
              >Making it Easy to Keep Property in the Family, We've Gone Social,
              and Take the Pulse Poll</a
            >
          </div>
          <div class="campaign">
            03/29/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=14f5aa0a05"
              title="Commercial Property Analysis, Appraisers Attend Professional Seminar , March for Babies&nbsp;"
              target="_blank"
              >Commercial Property Analysis, Appraisers Attend Professional
              Seminar , March for Babies&nbsp;</a
            >
          </div>
          <div class="campaign">
            03/18/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=217eaa5d77"
              title="Not Your Average Seminar, Featured City of the Week&nbsp;✅, Honoring Women Everyday&nbsp;"
              target="_blank"
              >Not Your Average Seminar, Featured City of the Week&nbsp;✅,
              Honoring Women Everyday&nbsp;</a
            >
          </div>
          <div class="campaign">
            03/01/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=f92806cf94"
              title="Property Information at Your Fingertips 🏡, Not Your Average Seminar, City of the Week&nbsp;✅"
              target="_blank"
              >Property Information at Your Fingertips 🏡, Not Your Average
              Seminar, City of the Week&nbsp;✅</a
            >
          </div>
          <div class="campaign">
            02/22/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=9aece2f914"
              title="Not Your Average Seminar, Check out the 88, Grow your Biz&nbsp;✅"
              target="_blank"
              >Not Your Average Seminar, Check out the 88, Grow your
              Biz&nbsp;✅</a
            >
          </div>
          <div class="campaign">
            02/15/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=b1e0565804"
              title="Last Day to File for 🏠 Exemption, Free Seminars for Business Owners, Celebrate Year of the&nbsp;🐶"
              target="_blank"
              >Last Day to File for 🏠 Exemption, Free Seminars for Business
              Owners, Celebrate Year of the&nbsp;🐶</a
            >
          </div>
          <div class="campaign">
            02/09/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=ae9a9ad31f"
              title="Free Tax Services, Honoring Animal Control, Property Tax Relief&nbsp;🏠"
              target="_blank"
              >Free Tax Services, Honoring Animal Control, Property Tax
              Relief&nbsp;🏠</a
            >
          </div>
          <div class="campaign">
            02/01/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=42dd63d8f3"
              title="Honoring the Life of Assessor Hahn, Biz Fed, City of the Week..."
              target="_blank"
              >Honoring the Life of Assessor Hahn, Biz Fed, City of the
              Week...</a
            >
          </div>
          <div class="campaign">
            01/26/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=292dc6cf1e"
              title="Cities Proclaim January as 🏠&nbsp;Homeowners' Exemption Awareness Month"
              target="_blank"
              >Cities Proclaim January as 🏠&nbsp;Homeowners' Exemption
              Awareness Month</a
            >
          </div>
          <div class="campaign">
            01/18/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=7c10ab7464"
              title="January Proclaimed as 🏠&nbsp;Homeowners' Exemption Awareness Month"
              target="_blank"
              >January Proclaimed as 🏠&nbsp;Homeowners' Exemption Awareness
              Month</a
            >
          </div>
          <div class="campaign">
            01/12/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=3f5cdf0b5f"
              title="Disaster Relief, Homeowners' Property Tax Exemption &amp; City of the Week"
              target="_blank"
              >Disaster Relief, Homeowners' Property Tax Exemption &amp; City of
              the Week</a
            >
          </div>
          <div class="campaign">
            01/04/2018 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=7754702876"
              title="What could you do with $70 dollars?"
              target="_blank"
              >What could you do with $70 dollars?</a
            >
          </div>
        </div>
      </accordion-group>
      <accordion-group #drop5>
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2017
            <i
              class="mt-1 float-end"
              [ngClass]="!drop5.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="display_archive">
          <div class="campaign">
            12/27/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=9baa2216e2"
              title="Pre-Paying Property Taxes, Ringing in the New Year &amp; Go Metro"
              target="_blank"
              >Pre-Paying Property Taxes, Ringing in the New Year &amp; Go
              Metro</a
            >
          </div>
          <div class="campaign">
            12/22/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=826f6eeb6e"
              title="REGISTER NOW: Assessor Resource Seminar"
              target="_blank"
              >REGISTER NOW: Assessor Resource Seminar</a
            >
          </div>
          <div class="campaign">
            12/21/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=4922ada440"
              title="Holiday Cheer, City of the Week &amp; Disaster Relief"
              target="_blank"
              >Holiday Cheer, City of the Week &amp; Disaster Relief</a
            >
          </div>
          <div class="campaign">
            12/14/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=8148cc600c"
              title="Disaster Relief, Holiday Parades, and Property Taxes...&nbsp;"
              target="_blank"
              >Disaster Relief, Holiday Parades, and Property Taxes...&nbsp;</a
            >
          </div>
          <div class="campaign">
            12/07/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=2a5b475f5e"
              title="Prang's Pick of the Week"
              target="_blank"
              >Prang's Pick of the Week</a
            >
          </div>
          <div class="campaign">
            11/30/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=391ed2134d"
              title="Prang's Pick of the Week"
              target="_blank"
              >Prang's Pick of the Week</a
            >
          </div>
          <div class="campaign">
            11/22/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=12b61dc59e"
              title="Prang's Pick of the Week!"
              target="_blank"
              >Prang's Pick of the Week!</a
            >
          </div>
          <div class="campaign">
            11/16/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=2a0e1dbfc5"
              title="Prang's Pick of the Week"
              target="_blank"
              >Prang's Pick of the Week</a
            >
          </div>
          <div class="campaign">
            11/09/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=6f5835298d"
              title="Prang's Weekly Picks"
              target="_blank"
              >Prang's Weekly Picks</a
            >
          </div>
          <div class="campaign">
            10/13/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=28f39e3fa9"
              title="2017 Annual Report Released!"
              target="_blank"
              >2017 Annual Report Released!</a
            >
          </div>
          <div class="campaign">
            09/25/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=8491d30ff9"
              title="Assessor Awarded Top Honor from International Association"
              target="_blank"
              >Assessor Awarded Top Honor from International Association</a
            >
          </div>
          <div class="campaign">
            09/04/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=f218900990"
              title="Happy Labor Day!"
              target="_blank"
              >Happy Labor Day!</a
            >
          </div>
          <div class="campaign">
            08/30/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=c335035932"
              title="Assessor Awarded for Modernizing Property Assessment Systems"
              target="_blank"
              >Assessor Awarded for Modernizing Property Assessment Systems</a
            >
          </div>
          <div class="campaign">
            08/25/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=c55d75b1a3"
              title="Homeowners Start Your Homework!"
              target="_blank"
              >Homeowners Start Your Homework!</a
            >
          </div>
          <div class="campaign">
            07/21/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=fecb99f912"
              title="2017 Assessment Roll Released!"
              target="_blank"
              >2017 Assessment Roll Released!</a
            >
          </div>
          <div class="campaign">
            06/29/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=b4648ad52c"
              title="Happy Independence Day!"
              target="_blank"
              >Happy Independence Day!</a
            >
          </div>
          <div class="campaign">
            06/20/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=fb56fd542b"
              title="Senior Replacement Dwelling Benefit"
              target="_blank"
              >Senior Replacement Dwelling Benefit</a
            >
          </div>
          <div class="campaign">
            06/16/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=bbff1dc26a"
              title="Happy Father's Day!"
              target="_blank"
              >Happy Father's Day!</a
            >
          </div>
          <div class="campaign">
            06/06/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=98a4f46ef0"
              title="LA Pride 2017"
              target="_blank"
              >LA Pride 2017</a
            >
          </div>
          <div class="campaign">
            05/26/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=b0589a5f71"
              title="Honoring Heroes on Memorial Day"
              target="_blank"
              >Honoring Heroes on Memorial Day</a
            >
          </div>
          <div class="campaign">
            05/15/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e6be8594ec"
              title="Peace Officers Memorial Day"
              target="_blank"
              >Peace Officers Memorial Day</a
            >
          </div>
          <div class="campaign">
            05/14/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=686e1e6c49"
              title="Happy Mother's Day!"
              target="_blank"
              >Happy Mother's Day!</a
            >
          </div>
          <div class="campaign">
            05/12/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=a9d5a75eb3"
              title="Assessor Discovers Time Capsule - Watch Now!"
              target="_blank"
              >Assessor Discovers Time Capsule - Watch Now!</a
            >
          </div>
          <div class="campaign">
            05/09/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=8211266ac4"
              title="Office of the Assessor Earns National Achievement for New Online Portal"
              target="_blank"
              >Office of the Assessor Earns National Achievement for New Online
              Portal</a
            >
          </div>
          <div class="campaign">
            03/31/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=846cfa36af"
              title="Honoring César Chávez"
              target="_blank"
              >Honoring César Chávez</a
            >
          </div>
          <div class="campaign">
            03/07/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=5339c959e4"
              title="Free Business Seminars!"
              target="_blank"
              >Free Business Seminars!</a
            >
          </div>
          <div class="campaign">
            01/25/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=efe6667cb6"
              title="Assessor Prang and Board of Supervisors Promote Tax Savings for Homeowners"
              target="_blank"
              >Assessor Prang and Board of Supervisors Promote Tax Savings for
              Homeowners</a
            >
          </div>
          <div class="campaign">
            01/03/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=cb060d5e28"
              title="Apply Now!"
              target="_blank"
              >Apply Now!</a
            >
          </div>
        </div>
      </accordion-group>
      <accordion-group #drop6>
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2016
            <i
              class="mt-1 float-end"
              [ngClass]="!drop6.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="display_archive">
          <div class="campaign">
            04/24/2017 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=420d7d1924"
              title="Remembering&nbsp;the Armenian Genocide"
              target="_blank"
              >Remembering&nbsp;the Armenian Genocide</a
            >
          </div>
          <div class="campaign">
            12/28/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=f7ce1fd2ca"
              title="We're Hiring!"
              target="_blank"
              >We're Hiring!</a
            >
          </div>
          <div class="campaign">
            12/08/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=41cb50e209"
              title="2016-17 Annual&nbsp;Secured Property Tax Deadline"
              target="_blank"
              >2016-17 Annual&nbsp;Secured Property Tax Deadline</a
            >
          </div>
          <div class="campaign">
            11/24/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=1257413157"
              title="Happy Thanksgiving!"
              target="_blank"
              >Happy Thanksgiving!</a
            >
          </div>
          <div class="campaign">
            11/21/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=621bfe460e"
              title="Deadline to File Assessment Appeals and Decline-in-Value Applications November 30th"
              target="_blank"
              >Deadline to File Assessment Appeals and Decline-in-Value
              Applications November 30th</a
            >
          </div>
          <div class="campaign">
            10/21/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=93d6c7f174"
              title="Porter Ranch: Deadline to Apply for&nbsp;Tax Relief is October 24th"
              target="_blank"
              >Porter Ranch: Deadline to Apply for&nbsp;Tax Relief is October
              24th</a
            >
          </div>
          <div class="campaign">
            10/20/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=7d5e69693a"
              title="Office of the Assessor Recognized by Quality and Productivity Commission&nbsp;"
              target="_blank"
              >Office of the Assessor Recognized by Quality and Productivity
              Commission&nbsp;</a
            >
          </div>
          <div class="campaign">
            10/07/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e56e0c69d4"
              title="2016 Annual Report Released!"
              target="_blank"
              >2016 Annual Report Released!</a
            >
          </div>
          <div class="campaign">
            09/11/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=3ec57a8eb7"
              title="Remembering 9/11"
              target="_blank"
              >Remembering 9/11</a
            >
          </div>
          <div class="campaign">
            09/05/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=f9d69f672f"
              title="Happy Labor Day!"
              target="_blank"
              >Happy Labor Day!</a
            >
          </div>
          <div class="campaign">
            07/19/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=22913843c1"
              title="Assessor Prang Secures $3.2 Million in Property Tax Relief for 50,000 Businesses"
              target="_blank"
              >Assessor Prang Secures $3.2 Million in Property Tax Relief for
              50,000 Businesses</a
            >
          </div>
          <div class="campaign">
            07/14/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e9a797ee19"
              title="2016 Assessment Roll Released!"
              target="_blank"
              >2016 Assessment Roll Released!</a
            >
          </div>
          <div class="campaign">
            07/11/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=dbdad5b284"
              title="We're Hiring!"
              target="_blank"
              >We're Hiring!</a
            >
          </div>
          <div class="campaign">
            07/06/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=c4034d5556"
              title="Summer Newsletter: Small Business Tax Relief, Assessment Roll, Mobile Mansions"
              target="_blank"
              >Summer Newsletter: Small Business Tax Relief, Assessment Roll,
              Mobile Mansions</a
            >
          </div>
          <div class="campaign">
            07/02/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=6180ab3899"
              title="Happy Fourth of July!"
              target="_blank"
              >Happy Fourth of July!</a
            >
          </div>
          <div class="campaign">
            06/13/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=99603b156a"
              title='Close the Mobile&nbsp;"Mansion" Loophole'
              target="_blank"
              >Close the Mobile&nbsp;"Mansion" Loophole</a
            >
          </div>
          <div class="campaign">
            05/27/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=364297df87"
              title="Memorial Day - Honoring Our Heroes"
              target="_blank"
              >Memorial Day - Honoring Our Heroes</a
            >
          </div>
          <div class="campaign">
            05/12/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=5fdbc08fb1"
              title="Parent-Child Property Transfer: Make it Easy to Keep Property in the Family"
              target="_blank"
              >Parent-Child Property Transfer: Make it Easy to Keep Property in
              the Family</a
            >
          </div>
          <div class="campaign">
            05/10/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=d77ddc8f7c"
              title="Culver City Community &amp; Real Estate Professionals Forum&nbsp;on&nbsp;June 2nd"
              target="_blank"
              >Culver City Community &amp; Real Estate Professionals
              Forum&nbsp;on&nbsp;June 2nd</a
            >
          </div>
          <div class="campaign">
            05/08/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=92c5bbcbd1"
              title="Happy Mother's Day"
              target="_blank"
              >Happy Mother's Day</a
            >
          </div>
          <div class="campaign">
            05/03/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=9c74096684"
              title="Holocaust Remembrance Day"
              target="_blank"
              >Holocaust Remembrance Day</a
            >
          </div>
          <div class="campaign">
            04/26/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=4428f6e93f"
              title="Happy Passover!"
              target="_blank"
              >Happy Passover!</a
            >
          </div>
          <div class="campaign">
            04/19/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=837bf1719c"
              title="SAVE THE DATE: Community/Real Estate Professionals Forum in Culver City"
              target="_blank"
              >SAVE THE DATE: Community/Real Estate Professionals Forum in
              Culver City</a
            >
          </div>
          <div class="campaign">
            03/24/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e65781b4b2"
              title="Norooz - The Persian New Year"
              target="_blank"
              >Norooz - The Persian New Year</a
            >
          </div>
          <div class="campaign">
            03/23/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=02bb16a0e9"
              title="2015-16 Property Tax Bills Due April 10th"
              target="_blank"
              >2015-16 Property Tax Bills Due April 10th</a
            >
          </div>
          <div class="campaign">
            03/22/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=cc320d3558"
              title="Los Angeles County Annual Report"
              target="_blank"
              >Los Angeles County Annual Report</a
            >
          </div>
          <div class="campaign">
            03/07/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=6900be0819"
              title="You're Invited: Free Business Seminars"
              target="_blank"
              >You're Invited: Free Business Seminars</a
            >
          </div>
          <div class="campaign">
            02/26/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=9a9e6a1b59"
              title="Reminder: Please RSVP to Community/Real Estate Professionals Forum"
              target="_blank"
              >Reminder: Please RSVP to Community/Real Estate Professionals
              Forum</a
            >
          </div>
          <div class="campaign">
            02/23/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=fb9fc4b79c"
              title="You're Invited: Community/Real Estate Professionals Forum"
              target="_blank"
              >You're Invited: Community/Real Estate Professionals Forum</a
            >
          </div>
          <div class="campaign">
            02/12/2016 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=e5b6eca6a8"
              title="Winter Newsletter: One Year Report, Homeowners' Exemption, and Tax Savings"
              target="_blank"
              >Winter Newsletter: One Year Report, Homeowners' Exemption, and
              Tax Savings</a
            >
          </div>
        </div>
      </accordion-group>
      <accordion-group #drop7>
        <div accordion-heading>
          <span class="dropdown-item clearfix">
            2015
            <i
              class="mt-1 float-end"
              [ngClass]="!drop7.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
            ></i>
          </span>
        </div>
        <div class="display_archive">
          <div class="campaign">
            10/21/2015 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=795d964b86"
              title="Fall Newsletter: Technology, Open Data, and Public Outreach"
              target="_blank"
              >Fall Newsletter: Technology, Open Data, and Public Outreach</a
            >
          </div>
          <div class="campaign">
            09/22/2015 -
            <a
              href="http://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&amp;id=014bd2c81d"
              title="The 2015 Annual Report is here!"
              target="_blank"
              >The 2015 Annual Report is here!</a
            >
          </div>
        </div>
      </accordion-group>
    </accordion>
  </div> -->

  <!--
  <ngb-accordion [closeOthers]="true" activeIds="static-1">
  <ngb-panel id="static-1" title="Simple">
    <ng-template ngbPanelContent>
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia
      aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
      sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica,
      craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
      occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus
      labore sustainable VHS.
    </ng-template>
  </ngb-panel>
  <ngb-panel id="static-2">
    <ng-template ngbPanelTitle>
      <span>&#9733; <b>Fancy</b> title &#9733;</span>
    </ng-template>
    <ng-template ngbPanelContent>
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia
      aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
      sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica,
      craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
      occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus
      labore sustainable VHS.
    </ng-template>
  </ngb-panel>
  <ngb-panel id="static-3" title="Disabled" [disabled]="true">
    <ng-template ngbPanelContent>
      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia
      aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
      sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica,
      craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
      occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus
      labore sustainable VHS.
    </ng-template>
  </ngb-panel>
</ngb-accordion>-->
</div>
